import { Injectable } from '@angular/core';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

/**
 * Servicio de permisos dinamicos para el modulo de alarmas infructuosas.
 *
 * Reemplaza los checks hardcoded de idareaagente que existian en:
 *  - home-agente.component.ts (validAgenteParaAlarmas)
 *  - alerta-flotante.component.ts (boton Gestionar, idareaagente 2 || 7)
 *
 * Los permisos se resuelven contra la tabla escenario_area via endpoint
 * /api/PGV/alarmastp/permisosArea y se cachean en memoria por sesion.
 */
@Injectable({ providedIn: 'root' })
export class AlarmasPermisosService {
  private cache: { puede_ver: boolean, puede_gestionar: boolean } = null;
  private cargando: Promise<void> = null;

  constructor(
    private gateway: GatewayService,
    private localSave: LocalSaveService,
  ) { }

  /**
   * Carga los permisos del area del agente logueado.
   * Idempotente: si ya hay cache, resuelve inmediatamente.
   * Si ya hay una carga en curso, retorna la misma promesa para evitar
   * requests duplicados.
   */
  cargar(): Promise<void> {
    if (this.cache) {
      return Promise.resolve();
    }
    if (this.cargando) {
      return this.cargando;
    }
    const usuario = this.localSave.get('usuarioPGV') || {};
    const idareaagente = usuario.idareaagente;
    if (idareaagente === undefined || idareaagente === null) {
      this.cache = { puede_ver: false, puede_gestionar: false };
      return Promise.resolve();
    }
    this.cargando = this.gateway
      .get('getPermisosAreaAlarmas', { idareaagente })
      .then((res: any) => {
        this.cache = {
          puede_ver: !!(res && Number(res.puede_ver) === 1),
          puede_gestionar: !!(res && Number(res.puede_gestionar) === 1),
        };
        this.cargando = null;
      })
      .catch(() => {
        this.cache = { puede_ver: false, puede_gestionar: false };
        this.cargando = null;
      });
    return this.cargando;
  }

  puedeVer(): boolean {
    return this.cache ? this.cache.puede_ver : false;
  }

  puedeGestionar(): boolean {
    return this.cache ? this.cache.puede_gestionar : false;
  }

  /**
   * Limpia el cache. Debe llamarse:
   *  - Tras modificar permisos desde la pantalla admin
   *  - En logout
   */
  invalidar(): void {
    this.cache = null;
    this.cargando = null;
  }
}
